// extracted by mini-css-extract-plugin
module.exports = {"emptyFeatured":"EmptyProductCard_emptyFeatured__Gl3I8","empty":"EmptyProductCard_empty__3GhhD"};